import React from 'react';
import {
  Panel,
  RefinementList,
} from 'react-instantsearch-dom';

function HashtagFilterPanel() {
  return (
    <div className="card bg-transparent border-0 mb-3">
      <div className="card-body ais-hide-counts">
        <Panel header="Filter by hashtag">
          <RefinementList
            attribute="hashtags.hashtag"
            limit={6}
            operator="and"
            showMore={true}
            showMoreLimit={15}
            searchable={true}
          />
        </Panel>
      </div>
    </div>
  );
}

export default HashtagFilterPanel;
